import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { EstadoFaseAnualModel, ResponseEstadoFaseAnualModel } from 'src/app/model/EstadoFaseAnual.model';
import { EstadoGeneralModel, ResponseEstadoGeneralModel } from 'src/app/model/EstadoGeneral';
import { ResponseUnidadEducativaModel, UnidadEducativaModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import { PlanMejoraService } from 'src/app/service/planMejora.service';
import { environment } from 'src/environments/environment';
import { JardinComponent } from '../../jardin.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-jardin-plan-mejora',
  templateUrl: './jardin-plan-mejora.component.html',
  styleUrls: ['./jardin-plan-mejora.component.css']
})
export class JardinPlanMejoraComponent implements OnInit {


  @ViewChild('modalInforme', { static: true }) modalInforme: TemplateRef<any>;
  @Input() simulacion: boolean;
  public componente:string="";
  uniEducativa = new UnidadEducativaModel(); 
  dataJardin = new JardinModel();
  cargando = true;
  estadoGeneralUE = new EstadoGeneralModel();
  estadoPlanMejora : number;
  estadoFaseAnual = new  EstadoFaseAnualModel();
  urlInformeExcelPME : string = "";

  apiEndpoint = environment.apiEndpoint;

  url:string ;
  urlSafe: SafeResourceUrl;
  
  constructor(
      private api: apiService,
      private planMejoraService: PlanMejoraService,
      private modal: NgbModal,
      public sanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {     
      this.componente="";
      this.cargando = true;
      this.dataJardin = this.api.dataJardin;
      this.urlInformeExcelPME =  environment.apiEndpoint + "jardin/imprimirInformeExcelPME/" + this.dataJardin.idJardinPeriodo;
      this.cargaInicial();
    }
  
    cargaInicial(){
      this.unidadEducativa(this.dataJardin);
      this.obtenerEstadoGeneralUE(this.dataJardin);
      this.getEstadosPlanMejora(this.dataJardin);
      this.getEstadosFaseAnualAnio(this.dataJardin);
    
     
    }

  irA(vista){
    //fase-estrategica, fase-anual
    //this.parent.menuVisible(vista);
    this.componente = vista;
  }

  unidadEducativa(dataJardin:JardinModel){
    this.api.API_POST_obtenerUnidadEducatica(dataJardin.id).subscribe((response: ResponseUnidadEducativaModel) => {
      this.uniEducativa = response.payload;  

    },
    (err) => {
      console.log(err)
    });      
  }

  obtenerEstadoGeneralUE(dataJardin:JardinModel){
    this.planMejoraService.API_POST_getEstadoGeneralUE(dataJardin.id).subscribe((response: ResponseEstadoGeneralModel) => {
      this.estadoGeneralUE = response.payload;  
    },
    (err) => {
      console.log(err)
    });      
  }

  getEstadosPlanMejora(dataJardin:JardinModel){
    this.planMejoraService.API_POST_getEstadosPlanMejora(dataJardin.id).subscribe((response: any) => {
      this.estadoPlanMejora = response.payload;  
    },
    (err) => {
      console.log(err)
    });      
  }

  getEstadosFaseAnualAnio(dataJardin:JardinModel){
    this.planMejoraService.API_POST_getEstadosFaseAnualAnio(dataJardin.id).subscribe((response: ResponseEstadoFaseAnualModel) => {
      this.estadoFaseAnual = response.payload;  
    },
    (err) => {
      console.log(err)
    });      
  }

  habilitarSeguimiento(){
    let disponible = false;
    if (this.estadoFaseAnual.estadoAnio1 
      || this.estadoFaseAnual.estadoAnio2
      || this.estadoFaseAnual.estadoAnio3) {
      disponible = true;
    }
    return disponible;
    
  }

  imprimir(){
    this.url = this.apiEndpoint + "jardin/imprimirInformePME/" + this.dataJardin.idJardinPeriodo;
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.modal.open(this.modalInforme, { size: 'xl' });
  }
  
  close(){
    this.modal.dismissAll();
  }

}
